import { render } from "./studentresult.vue?vue&type=template&id=3c45e3a0&scoped=true"
import script from "./studentresult.vue?vue&type=script&lang=js"
export * from "./studentresult.vue?vue&type=script&lang=js"

import "./studentresult.vue?vue&type=style&index=0&id=3c45e3a0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c45e3a0"]])

export default __exports__